import cn from 'classnames'
import React, { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { SearchKb } from 'ducks/ticketing'
import { doInsertKbLink } from 'ducks/chat/actions/articles'
import styles from './styles.less'

export default function ChatSearchKb({ messageComposerRef }) {
  const dispatch = useDispatch()
  const insertKbLink = useCallback(
    (articleID, knowledgeBaseId, evt) => {
      evt.preventDefault()
      evt.stopPropagation()
      if (messageComposerRef.current) {
        return dispatch(
          doInsertKbLink(
            articleID,
            knowledgeBaseId,
            // eslint-disable-next-line no-underscore-dangle
            messageComposerRef.current.messageComposerInput._editorRef
          )
        )
      }
      return Promise.reject('Editor is not ready')
    },
    [dispatch, messageComposerRef]
  )

  return (
    <SearchKb
      insertKbLink={insertKbLink}
      className={cn(styles['chat-kb-search'], 'chat-kb-search')}
      menuUpward
    />
  )
}
